import { Module } from "vuex";
import { RootState } from "../types";
import { AuthState } from "./types";
import { actions } from "./actions";
import { getters } from "./getters";
import { mutations } from "./mutations";

export const state: AuthState = {
  user: null,
};

const namespaced: boolean = true;

export const auth: Module<AuthState, RootState> = {
  namespaced,
  state,
  actions,
  getters,
  mutations,
};
